import { selectIsImpersonating, useImpersonationSelector } from '@revelio/auth';

/** Saved preferences are read-only while impersonating another user. */
export const useCanSavePreferences = (): boolean =>
  !useImpersonationSelector(selectIsImpersonating);
